﻿/**
 * Converts an object to a URL query string.
 * @param query An object containing query parameters. Undefined values are excluded from the result.
 * @returns A URL-encoded query string (without leading ?), or undefined if the query is null/undefined.
 */
export default function objectToQueryString<T extends Record<string, string | undefined> | undefined>(query: T): T extends undefined ? undefined : string {
	if (query == null) {
		return undefined as any;
	}

	let requestUrl = "";
	for (let key of Object.keys(query)) {
		const value = query[key];
		if (value != null) {
			requestUrl += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
		}
	}

	return requestUrl.substring(0, requestUrl.length - 1) as any;
}
